<template>
    <div>
        <navbar></navbar>
            <div v-if="loading" class="column is-full records-table">
                <Loader></Loader>
            </div>
        <section v-else>
            <div class="container box record-box">
                <div class="columns">
                    <div class="column">
                        <div class="notification is-danger-light" v-if="has_error">
                            <ul v-for="error in this.errors">
                                <li>{{error.detail}}</li>
                            </ul>
                        </div>
                        <fieldset :disabled=read_only v-if="!loading">
                            <form class="record-form" @submit.prevent="submit">
                                <div class="field"><label class="label is-pulled-left">Location</label>
                                    <div class="control">
                                        {{current_location}}
                                    </div>
                                </div>

                                <div class="field"><label class="label is-pulled-left">First Name</label>
                                    <div class="control"><input class="input" type="text" v-model="first_name"/>
                                    </div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Middle Name</label>
                                    <div class="control"><input class="input" type="text" v-model="middle_name"/></div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Last Name</label>
                                    <div class="control"><input class="input" type="text" v-model="last_name"/>
                                    </div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Burial Number</label>
                                    <div class="control"><input class="input" type="text" v-model="burial_number"/>
                                    </div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Section</label>
                                    <div class="control">
                                        <div class="select">
                                            <select v-model="section">
                                                <option disabled value="">Select A Section</option>
                                                <option
                                                        v-for="option in sections"
                                                        :key="option.id"
                                                        v-bind:value="option">
                                                    {{ option.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Lot</label>
                                    <div class="control"><input class="input" type="text" v-model="lot"/></div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Space</label>
                                    <div class="control"><input class="input" type="text" v-model="space"/></div>
                                </div>
                                <div class="field">
                                    <label class="label is-pulled-left">Tier</label>
                                    <div class="control">
                                        <div class="select">
                                            <select v-model="tier">
                                                <option selected disabled value>Select a Tier</option>
                                                <option value="A">A</option>
                                                <option value="B">B</option>
                                                <option value="C">C</option>
                                                <option value="D">D</option>
                                                <option value="E">E</option>
                                                <option value="F">F</option>
                                                <option value="G">G</option>
                                                <option value="H">H</option>
                                                <option value="I">I</option>
                                                <option value="J">J</option>
                                                <option value="K">K</option>
                                                <option value="L">L</option>
                                                <option value="M">M</option>
                                                <option value="N">N</option>
                                                <option value="O">O</option>
                                                <option value="P">P</option>
                                                <option value="Q">Q</option>
                                                <option value="R">R</option>
                                                <option value="S">S</option>
                                                <option value="T">T</option>
                                                <option value="U">U</option>
                                                <option value="V">V</option>
                                                <option value="W">W</option>
                                                <option value="X">X</option>
                                                <option value="Y">Y</option>
                                                <option value="Z">Z</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Lot Owner</label>
                                    <div class="control"><input class="input" type="text" v-model="lot_owner"/></div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Date Of Birth</label>
                                    <div class="control"><input class="input" type="date" v-model="date_of_birth"/>
                                    </div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Date Of Death</label>
                                    <div class="control"><input class="input" type="date" v-model="date_of_death"/>
                                    </div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Date Of Burial</label>
                                    <div class="control"><input class="input" type="date" v-model="date_of_burial"/>
                                    </div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Location Of Death</label>
                                    <div class="control"><input class="input" type="text" v-model="location_of_death"/>
                                    </div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Mortuary</label>
                                    <div class="control"><input class="input" type="text" v-model="mortuary"/></div>
                                </div>
                                <div class="field">
                                    <label class="label is-pulled-left">Burial Code</label>
                                    <div class="control">
                                        <div class="select">
                                            <select v-model="burial_code">
                                                <option selected value disabled>Select A Burial Code</option>
                                                <option value="s">Single</option>
                                                <option value="d">Double</option>
                                                <option value="l">Lawncrypt</option>
                                                <option value="m">Mausoleum</option>
                                                <option value="e">East</option>
                                                <option value="w">West</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="field">
                                    <label class="label is-pulled-left">Sub Burial Code</label>
                                    <div class="control">
                                        <div class="select">
                                            <select v-model="sub_burial_code">
                                                <option value selected disabled>Select A Sub Burial Code</option>
                                                <option value="front">Front</option>
                                                <option value="back">Back</option>
                                                <option value="top">Top</option>
                                                <option value="bottom">Bottom</option>
                                                <option value="front-top">Front Top</option>
                                                <option value="front-bottom">Front Bottom</option>
                                                <option value="back-top">Back Top</option>
                                                <option value="back-bottom">Back Bottom</option>
                                                <option value="cremation">Cremation</option>
                                                <option value="niche">Niche</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Marker</label>
                                    <div class="control">
                                        <label class="radio">
                                            <input type="radio" name="marker" value="true" v-model="marker">
                                            Yes
                                        </label>
                                        <label class="radio">
                                            <input type="radio" name="marker" value="false" v-model="marker">
                                            No
                                        </label>
                                    </div>
                                </div>
                                <div class="field"><label class="label is-pulled-left">Comment</label>
                                    <div class="control is-pulled-left text-control">
                                        <textarea class="textarea" v-model="comment"></textarea>
                                    </div>
                                </div>
                            </form>
                        </fieldset>
                        <div v-if="!read_only" class="field is-grouped is-pulled-left">
                            <div class="control is-pulled-left">
                                <button class="button is-primary submit-button" v-bind:class="{'is-loading': submitting}" @click="submit">Submit</button>
                            </div>
                            <div class="control is-pulled-right">
                                <button class="button is-danger submit-button" v-bind:class="{'is-loading': deleting}" @click="this.delete">Delete</button>
                            </div>
                        </div>
                        <div v-if="read_only && user_can_edit" class="field">
                            <div class="control is-pulled-left">
                                <button class="button is-primary submit-button" @click="edit">Edit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Navbar from "../components/Navbar";
    import Autocomplete from "../components/Autocomplete";
    import Loader from "../components/Loader";

    export default {
        name: "Record",
        components: {Autocomplete, Navbar, Loader},
        data() {
            return {
                last_name: "",
                first_name: "",
                middle_name: "",
                burial_number: "",
                space: "",
                tier: "",
                section: "",
                lot: "",
                lot_owner: "",
                date_of_birth: "",
                date_of_death: "",
                date_of_burial: "",
                location_of_death: "",
                mortuary: "",
                burial_code: "",
                sub_burial_code: "",
                size_code: "",
                marker: false,
                vase_code: "",
                comment: "",
                sections: [],
                sections_placeholder: "Choose a location",
                has_error: false,
                errors: [],
                mortuaries: [],
                read_only: false,
                submitting: false,
                loading: false,
                deleting: false
            }
        },
        computed: {
            current_location() {
                return this.$store.getters.default_location_name
            },
            current_location_id() {
                return this.$store.getters.default_location_id
            },
            user_can_edit(){
                let locations = this.$store.state.user.locations
                for(var i=0; i < locations.length; i++) {
                    if(locations[i].id === this.current_location_id)
                    {
                        let roles = locations[i].roles
                        for(var j=0; j < roles.length; j++)
                        {
                            if(roles[j].role_id === 2)
                            {
                                return true
                            }
                        }
                    }
                }

                return false
            }
        },
        mounted() {
            this.getOptions()

            // Display data if this is not a new record.
            let id = this.$route.params.id
            if (typeof id !== 'undefined') {
                // Get record with this id
                this.getRecord(id)
                // Mark Form as disabled
                this.read_only = true
            }
        },
        methods: {
            writeableLocations() {
                let locations = [];
                this.$store.state.user.locations.forEach(function (location) {
                    location.roles.forEach(function (role) {
                        if (role.id === 2) {
                            locations.push(location)
                        }
                    });
                });

                return locations
            },
            edit() {
                this.read_only = false
            },
            getOptions() {
                let url = process.env.VUE_APP_API
                url = url + '/locations/' + this.current_location_id + '/sections?limit=200'
                this.$http.get(url)
                    .then(response => {
                        this.sections = response.data.data
                        this.sections_placeholder = "Choose a Section"
                    })
                url = process.env.VUE_APP_API
                url = url + '/locations/' + this.current_location_id + '/mortuaries'
                this.$http.get(url)
                    .then(response => {
                        this.mortuaries = response.data.data
                    })
            },
            getRecord(id) {
                this.loading = true
                this.errors = []
                let url = process.env.VUE_APP_API
                url = url + '/locations/' + this.current_location_id + '/burial-records/' + id
                this.$http.get(url)
                    .then(response => {
                        let data = response.data.data
                        this.last_name = data.last_name
                        this.first_name = data.first_name
                        this.middle_name = data.middle_name
                        this.burial_number = data.burial_number
                        this.space = data.space
                        this.tier = data.tier
                        this.section = data.section
                        this.lot = data.lot
                        this.lot_owner = data.lot_owner
                        this.date_of_birth = data.date_of_birth
                        this.date_of_death = data.date_of_death
                        this.date_of_burial = data.date_of_burial
                        this.location_of_death = data.location_of_death
                        this.mortuary = data.mortuary
                        this.burial_code = data.burial_code
                        this.sub_burial_code = data.sub_burial_code
                        this.size_code = data.size_code
                        this.marker_code = data.marker_code
                        this.vase_code = data.vase_code
                        this.comment = data.comment
                        this.loading = false
                    })
            },
            submit() {
                this.submitting = true
                this.errors = []
                let url = process.env.VUE_APP_API
                url = url + "/locations/" + this.current_location_id + "/burial-records"

                let method = "post";

                let id = this.$route.params.id
                if (typeof id !== 'undefined') {
                    url = url + "/" + id
                    method = "patch";
                }

                let data = {data: {
                            last_name: this.last_name,
                            first_name: this.first_name,
                            middle_name: this.middle_name,
                            burial_number: this.burial_number,
                            space: this.space,
                            tier: this.tier,
                            section_id: this.section,
                            lot: this.lot,
                            lot_owner: this.lot_owner,
                            date_of_birth: this.date_of_birth,
                            date_of_death: this.date_of_death,
                            date_of_burial: this.date_of_burial,
                            location_of_death: this.location_of_death,
                            mortuary: this.mortuary,
                            burial_code: this.burial_code,
                            size_code: this.size_code,
                            marker_code: this.marker_code,
                            vase_code: this.vase_code,
                            comment: this.comment,
                    }};

                if(method == "post"){
                    this.$http.post(url,data)
                        .then(resp => {
                            this.read_only = true;
                            this.submitting = false;
                            let id = resp.data.data.id;
                            let path = '/record/' + id
                            this.$router.push({path: path})
                        })
                        .catch(err => {
                            this.submitting = false
                            this.has_error = true
                            this.errors = err.response.data.errors
                            window.scrollTo(0, 0)
                        })
                }
                if(method == "patch")
                {
                    this.$http.patch(url,data)
                        .then(resp => {
                            this.read_only = true;
                            this.submitting = false
                            let id = resp.data.data.id;
                            let path = '/record/' + id
                            this.$router.push({path: path})
                        })
                        .catch(err => {
                            this.submitting = false
                            this.has_error = true
                            this.errors = err.response.data.errors
                            window.scrollTo(0, 0)
                        })
                }

            },
            delete(){
                this.deleting = true;
                this.errors = [];
                let url = process.env.VUE_APP_API;
                let id = this.$route.params.id;
                url = url + '/locations/' + this.current_location_id + '/burial-records/' + id;
                this.$http.delete(url)
                    .then(response => {
                        this.read_only = true;
                        this.deleting = false;
                        let path = '/records';
                        this.$router.push({path: path})
                    })
                    .catch(err => {
                        this.deleting = false;
                        this.has_error = true;
                        this.errors = err.response.data.errors;
                        window.scrollTo(0, 0);
                    })
            }
        },
    }
</script>

<style scoped>
    .record-form {
        width: 100%;
    }

    .record-box {
        max-width: 800px;
        margin-top: 100px;
        padding: 50px;
    }

    .text-control {
        width: 100%;
    }

    .is-danger-light {
        border-color: #f14668;
        color: #cc0f35;
        background-color: #feecf0;
    }

    .submit-button {
        margin-top: 15px;
    }
</style>